import { createSelector } from '@reduxjs/toolkit'

export const selectShareVideoData = createSelector(
  (state: any) => state.shareVideo,
  (shareVideo) => shareVideo
)
